import React from 'react';
import { Helmet } from 'react-helmet';
import imageSquare from '../../images/twitter_square.png';
import imageWide from '../../images/twitter_wide.png';
import config from '../../../gatsby-config';
const configSiteUrl = config.siteMetadata?.siteUrl as string | undefined;

interface IImageProps {
    src: string;
    alt?: string;
}

export interface ITwitterCardProps {
    title?: string,
    type?: 'summary' | 'summary_large_image',
    description?: string,
    siteHandle?: string,
    creator?: string,
    url?: string,
    image?: IImageProps,
}

export const TwitterCard: React.FunctionComponent<ITwitterCardProps> = props => {
    const type = props.type ?? 'summary_large_image';
    const creator = props.creator ?? props.siteHandle;
    const imageProps = props.image ?? {
        src: type === 'summary' ? imageSquare : imageWide,
        alt: 'axesCheck powered by axes4',
    };
    const absoluteImageUri = imageProps.src.startsWith('http')
        ? imageProps.src
        : `${configSiteUrl}/${imageProps.src.replace(/^\//, '')}`;

    return (
        <Helmet>
            <meta id="twitterCardType" name="twitter:card" content={type}/>
            {props.title && <meta id="twitterCardTitle" name="twitter:title" content={props.title}/>}
            {props.siteHandle && <meta id="twitterCardHandle" name="twitter:site" content={props.siteHandle}/>}
            {props.description && <meta id="twitterCardDescription" name="twitter:description" content={props.description}/>}
            {props.creator && <meta id="twitterCardCreator" name="twitter:creator" content={creator}/>}
            {props.url && <meta id="twitterCardUrl" name="twitter:url" content={props.url}/>}
            {absoluteImageUri && <meta id="twitterCardImage" name="twitter:image" content={absoluteImageUri}/>}
            {imageProps && imageProps.alt && <meta id="twitterCardImageAlt" name="twitter:image:alt" content={imageProps.alt}/>}
        </Helmet>
    );
};
